var _circle, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBCabinetProfileIcon4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8.25,
    stroke: "#737378",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 9.2998,
    width: 18,
    height: 1.4,
    fill: "#737378"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.65039C10.3407 1.65039 10.7141 1.80261 11.1084 2.17773C11.5062 2.55636 11.8945 3.1357 12.2344 3.90039C12.9133 5.42812 13.3496 7.58404 13.3496 10C13.3496 12.416 12.9133 14.5719 12.2344 16.0996C11.8945 16.8643 11.5062 17.4436 11.1084 17.8223C10.7141 18.1974 10.3407 18.3496 10 18.3496C9.65934 18.3496 9.28594 18.1974 8.8916 17.8223C8.49375 17.4436 8.10549 16.8643 7.76562 16.0996C7.0867 14.5719 6.65039 12.416 6.65039 10C6.65039 7.58404 7.0867 5.42812 7.76562 3.90039C8.10549 3.1357 8.49375 2.55636 8.8916 2.17773C9.28594 1.80261 9.65934 1.65039 10 1.65039Z",
    stroke: "#737378",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBCabinetProfileIcon4);
export default __webpack_public_path__ + "static/media/b_cabinet_profile_icon4.375afe800ec9bc64f3cd6235c692a5e3.svg";
export { ForwardRef as ReactComponent };